import { render } from "./SitesByCustomer.vue?vue&type=template&id=0ed7467d"
import script from "./SitesByCustomer.vue?vue&type=script&lang=js"
export * from "./SitesByCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__